import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import useApis from "../../services/useAPI";
import { Spinner } from "react-bootstrap";
import { accessError } from "../../utils/constants";
import { ErrorDisplay } from "../Errors/ErrorDisplay";

/**
 * WellnessCollectSample component
 *
 * This component facilitates the collection of a sample for wellness testing.
 * It presents the user with consent steps that must be acknowledged before
 * proceeding. It validates user input and submits the data to the server,
 * navigating to the next step upon success.
 *
 * @returns {JSX.Element} The rendered component for collecting a wellness sample.
 */

export default function WellnessCollectSample() {
  const { primaryBarcode } = useParams();
  const navigate = useNavigate();
  const { callApi, setShowError, resultPost, serverError, resultGet } = useApis();
   const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");


  const barcodeValue = primaryBarcode?.primaryBarcode || primaryBarcode;
  const typeUrl = `/api/dashboard/check-test/${barcodeValue}/`;

  useEffect(() => {
    if (barcodeValue) {
      setIsLoading(true);
      callApi({}, typeUrl, "GET");
    }
  }, [barcodeValue, typeUrl]);

  useEffect(() => {
    if (!resultGet) return;
    const hasValidStage =
      resultGet.activation_stage === "collect-sample" ||
      resultGet.activation_stage === "personal-details";
    if (resultGet.activation_stage === null || (!hasValidStage)) {
      setError(accessError);
    }
    else if (hasValidStage) {
      setIsLoading(false);
    } else {
      setError("");
    }
  }, [resultGet]);

  useEffect(() => {
    if (resultPost) {
      navigate(`/time-administered/${primaryBarcode}`);
    } else {
      setShowError(true);
    }
  }, [resultPost]);

  useEffect(() => {
    setError(error || serverError);
  }, [serverError, error])


  if (error) {
    return <ErrorDisplay error={error} />;
  }

  if (isLoading) {
    return (
      <div className="text-center">
        <Spinner animation="border" className="my-custom-spinner" />
      </div>
    );
  }

  return (
    <Navigate to={`/time-administered/${primaryBarcode}`} />
  );
}
